import { computed, ref } from 'vue'

import { toOperationView } from '../utils/operation'
import type { Deployment, Service, ServiceOverview, Version } from '../api'

export function createServiceDetailStore(deps: {
  services: { overviewGet: (id: number) => Promise<ServiceOverview> }
  versions: { list: (serviceId: number) => Promise<Version[]> }
  deployments: { list: (serviceId: number) => Promise<Deployment[]> }
}) {
  const overview = ref<ServiceOverview | null>(null)
  const versions = ref<Version[]>([])
  const deployments = ref<Deployment[]>([])
  const loading = ref(false)

  const service = computed<Service | null>(() => overview.value?.service || null)
  const health = computed(() => overview.value?.health || null)
  const operationView = computed(() => overview.value ? toOperationView(overview.value.operation) : null)

  async function load(id: number) {
    loading.value = true
    try {
      overview.value = await deps.services.overviewGet(id)
      versions.value = await deps.versions.list(id)
      deployments.value = await deps.deployments.list(id)
    } finally {
      loading.value = false
    }
  }

  return {
    overview,
    versions,
    deployments,
    loading,
    service,
    health,
    operationView,
    load,
  }
}
